import React from "react";
import { stockLabel } from "../lib/stock";

export default function StockBadge({ stock, className = "", testid }) {
  const label = stockLabel(stock);
  if (!label) return null;
  const out = stock <= 0;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-medium tracking-wide border whitespace-nowrap ${
        out
          ? "bg-[var(--bg-cream)]/95 text-[var(--muted-fg)] border-[var(--border)]"
          : "bg-[var(--bg-cream)]/95 text-[var(--terracotta)] border-[var(--terracotta)]/30"
      } ${className}`}
      data-testid={testid}
    >
      {label}
    </span>
  );
}
